import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 402 && !window.location.pathname.startsWith("/billing")) {
    import("sonner").then(({ toast }) => toast.error(e.response.data?.detail || "Your plan needs attention", {
      action: { label: "Billing", onClick: () => { window.location.href = "/billing"; } },
    }));
  }
  return Promise.reject(e);
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const fileUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const money = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(Number(n) || 0);

export const STATUS = {
  lead: "Lead", design: "Design", estimating: "Estimating", pre_start: "Pre-start", in_progress: "In progress", complete: "Complete", on_hold: "On hold",
};

export const uid = () => Math.random().toString(36).slice(2, 12);

export async function streamPost(path, body, onDelta) {
  const res = await fetch(`${BACKEND}/api${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || `Request failed (${res.status})`);
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.delta) onDelta(ev.delta);
    }
  }
}
